<template>
  <div>
    <van-nav-bar
      title="提现"
      left-text=""
      left-arrow
      @click-left="$router.push('/member/members')"
    >
      <template #right>
        <!-- <van-icon name="wechat" size="25" @click="openQchat()" /> -->
        <!-- <van-image
          width="28px"
          height="22px"
          :src="require('../assets/images/chatbar.png')"
          @click="openQchat()"
        /> -->
        <span @click="openQchat()" class="chatTextDesign">在线客服</span>
      </template>
    </van-nav-bar>
    <van-form @submit="getAccountbank">
      <!-- <van-row class="rowStyle">
        <van-col span="5" style="line-height: 30px"
          ><span>当前余额:</span></van-col
        >
        <van-col span="9" style="text-align: left; line-height: 30px"
          ><span>{{ cash }}元</span>
        </van-col>
        <van-col span="10" style="text-align: right"
          ><router-link to="information/withdrawal_pass"
            ><van-button
              type="info"
              style=" height: 32px;
                padding: 0 15px;
                font-size: 14px;
                border-radius: 25px;
              "
              >修改提现密码</van-button
            ></router-link
          ></van-col
        >
      </van-row> -->

      <div id="rechargetop">
        <!-- <van-cell title="当前余额"> -->
        <!-- <template #default>
            <span>{{ cash }}元</span>
          </template> -->
        <!-- </van-cell> -->
        <h5>提现金额</h5>
        <van-field
          v-model="money"
          type="digit"
          name="money"
          label="¥"
          placeholder="请输入提现金额（100元整倍数）"
          style="
            margin-top: -10px;
            margin-bottom: -10px;
            margin-left: 0px;
            background-color: #f0f0f0;
          "
          label-width="30px"
          input-align="left"
          autocomplete="off"
        />

        <van-row>
          <van-col span="12">
            <h4>余额 {{ cash }} 元</h4>
          </van-col>
          <van-col span="12" v-if="is_non_withdrawable == 1">
            <h4>
              可提现额 &nbsp {{ withdrawable_amount }} 元<van-icon
                name="question-o"
                color="#D02E27"
                @click="showPopup"
              />
            </h4>
          </van-col>
        </van-row>
      </div>
  <div v-if="selected_type == 3" id="gxpay"
     style="display:flex; align-items:center; font-size:14px; padding-left:15px; gap:8px;">

  <p>USDT:</p>
  <p id="usdt_amount"></p>

  <p>汇率:</p>
  <p>{{ usdt.exchange_rate }}</p>

</div>
        <div v-if="selected_type == 2" id="gxpay">
        <van-field
          v-if="selected_type == 2"
          v-model="gxpay_id"
          type="digit"
          label="Gxpay ID"
          placeholder="请输入Gxpay ID"
          input-align="right"
          style="color: #000000"
        >
          <template #button>
            <van-checkbox v-model="confirmChecked">已核对确认</van-checkbox>
          </template>
        </van-field>
      </div>
      <div class="recharge-notice" v-html="notice_1_1"></div>
      <div id="passwordstyle">
        <van-row>
          <h4>提现密码</h4>
        </van-row>

        <van-row class="inputBg" id="inputAmountWithdraw">
          <img style="width: 20px; padding: 10px" src="../assets/images/lockpw.png" />
          <van-field
            v-model="password"
            type="password"
            placeholder="请输入提现密码"
            input-align="left"
            autocomplete="new-password"
          >
          </van-field>
        </van-row>
      </div>
      <br />
      <van-row class="autofill" v-for="(item, index) in auto_fill_amounts" :key="index">
        <van-col span="6" v-for="(item1, index1) in item" :key="index1">
          <van-button
            class="autofillbtn"
            round
            plain
            hairline
            native-type="button"
            type="danger"
            size="small"
            @click="handleAmount(item1)"
          >
            {{ item1 }}元
          </van-button>
        </van-col>
      </van-row>

      <div style="margin-left: 15px">
        <h4 style="margin-left: 5px">请选择提款类型</h4>
      </div>
      <van-radio-group v-model="radio">
        <van-row
          v-for="(item, index) in withdrawType"
          :key="index"
          clickable
          @click="changeInstructions(index, item.type)"
          class="rechargeTypeBg"
        >
          <van-col span="4">
            <p style="text-align: center; margin: 2px">
              <img style="height: 25px" src="../assets/images/recharge1.png" />
            </p>
          </van-col>
          <van-col span="16">
            <p style="margin: 2px">{{ item.name }}</p>
          </van-col>
          <van-col span="4">
            <p style="margin: 2px"><van-radio :name="index" /></p>
          </van-col>
        </van-row>
      </van-radio-group>

      <div id="submitbtn" style="padding-top: 10px">
        <van-button size="normal" type="danger" block
          >确认提现 {{ button_text }}</van-button
        >
      </div>
      <!-- <van-popup
        v-model="rechargeMaxPopup"
        closeable
        close-icon="close"
        position="bottom"
        :style="{ height: '15%' }"
      >
        <div>
          <p style="text-align: center; margin-top: 15%">{{ Recharge_Max }}</p>
        </div>
      </van-popup> -->
      <van-row
        v-if="withdraw_fee_percentage == 0 && withdraw_fee_min == 0"
        class="rowStyle"
        style="border-bottom: none"
      >
      </van-row>
      <!-- <van-row v-else class="rowStyle" style="border-bottom: none">
        <van-col span="24" style="line-height: 25px"
          ><p style="color: red; margin: 0">温馨提醒：</p>
          <p style="margin: 0">
            提现手续费按提现金额的{{ withdraw_fee_percentage }}%收取，{{
              withdraw_fee_min
            }}元起。
          </p></van-col
        >
      </van-row> -->
    </van-form>
    <!-- ============================== Start change channel popup ========================== -->
    <van-popup
      v-model="showTradeChannelPopup"
      closeable
      id="tradingAgreePop"
      style="width: 85%"
    >
      <div
        v-html="trade_rules_content_top"
        style="overflow-y: scroll; max-height: 320px; margin: 10px"
      ></div>
      <div style="text-align: center; padding: 0px 10px">
        <van-button
          type="danger"
          size="large"
          @click="agreeTradeRules"
          style="width: 50%; height: 30%; padding: 3px; border-radius: 6px"
          >我已经明白
        </van-button>
        <div
          v-html="trade_rules_content_bottom"
          style="text-align: center; margin: 10px"
        ></div>
      </div>
    </van-popup>
    <!-- ============================== End change channel popup ========================== -->
     <!--second withdraw poup-->
      <van-popup v-model="withdrawSecondPopup"  style="width: 320px;height:auto;border-radius: 16px;">
        <div class="popupContent" style="margin-top:10%">
          <div v-html="withdraw_popup_content">
          </div>
          <div class="van-hairline--top van-dialog__footer">
          
         <button type="button" class="van-button van-button--default van-button--large van-dialog__confirm van-hairline--left" @click="cancelRedirection">{{ left_side_button_name }}</button>
           
         <button type="button" :disabled="withdrawDisabled" class="van-button van-button--default van-button--large van-dialog__cancel" style="color: rgb(208, 46, 39);"@click="withdrawal">{{ right_side_button_name }}</button>
          </div>
        </div>
      </van-popup>
      <!--end-->
    <CommonLoading ref="commonLoader"></CommonLoading>
  </div>
</template>

<script>
import { Dialog } from "vant";
import { Toast } from "vant";
import { Browser } from "@capacitor/browser";
import { Capacitor } from "@capacitor/core";
import CommonLoading from "./CommonLoading";
import { version } from "../../package";

export default {
  name: "Withdrawal",
  components: {
    CommonLoading,
  },
  data() {
    return {
      cash: 0,
      money: "",
      password: "",
      popupStatus: "",
      timbaoAnulaizedInterestRate: "",
      timebaoRate: "",
      account: "",
      card: "",
      name: "",
      address: "",
      bankStatus: false,
      showTradeChannelPopup: false,
      trade_rules_content_top: "",
      trade_rules_content_bottom: "",
      withdraw_fee_percentage: 0,
      withdraw_fee_min: 0,
      qserver_url: "",
      withdrawType: [],
      notice_1_1: "",
      notice_2_1: "",
      notice_2_2: "",
      selectedTypeId: "",
      auto_fill_amounts: [],
      button_text: null,
      // rechargeMaxPopup: false,
      // Recharge_Max: "",
      radio: 1,
      gxpay_id: "",
      selected_type: "",
      confirmChecked: false,
      withdrawable_amount: 0,
      is_non_withdrawable: false,
      withdraw_popup_content:"",
      withdrawSecondPopup:false,
      withdraw_popup_content:"",
      right_side_button_name:"",
      left_side_button_name:"",
      mobile_left_side_redirection:"",
       usdt:{
        user_withdraw_address:"",
        usdt_amount:0,
        exchange_rate:0,
        is_user_bank:0,
      },
      withdrawDisabled:false,

    };
  },
   watch: {
  'money'(val) {
    console.log("hey");
    let that=this;
    val = val.replace(/\D/g, '')
    if (val.length === 1) {
      val = val.replace(/[^1-9]/g, '')
    }

    that.money = val

    if (val) {
  if(that.usdt.exchange_rate>0){
     let usdt_amount = document.getElementById("usdt_amount");
    usdt_amount.innerHTML=(that.money/that.usdt.exchange_rate).toFixed(2);
     }
    } else {
       usdt_amount.innerHTML = 0;
    }
  }
},
  methods: {
    cancelRedirection(){
      this.$router.push(this.mobile_left_side_redirection);
    },
    showPopup() {
      this;
      Dialog.confirm({
        title: "友情提醒",
        message: "任何充值都必须配资后买入才可提现。买入额为充值额的10倍即可全额提现。",
        cancelButtonText: "继续提现",
        showCancelButton: false,
      });
    },
    openQchat() {
      if (Capacitor.getPlatform() === "android") {
        //check if android app, if android app use native plugin to open popup
        Browser.open({ url: this.$store.state.chat_server_url });
      } else {
        window.open(this.$store.state.chat_server_url);
      }
    },
    get_qchat_server_url() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "server_url",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            var data = res.data.data;
            that.qserver_url = data;
            that.$store.commit("chatServerUrl", that.qserver_url);
          } else if (res.data.code == 0) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
    getUser() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "user",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (res.data.code === 1) {
            that.cash = resData.data.cash;
            that.withdrawable_amount = res.data.data.withdrawable_amount;
            that.is_non_withdrawable = res.data.data.is_non_withdrawable;
            that.usdt.user_withdraw_address=res.data.data.withdraw_address;
          } else if (res.data.code === 0 || res.data.code === -1) {
            that.$toast.fail(resData.msg);
          }
        });
    },
    getUserInfo() {
      let that = this;
      // let toast = that.$toast.loading({
      //   forbidClick: true,
      // });
      that.$refs.commonLoader.showCommonLoadigIcon();
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "user_info",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          // toast.clear();
          that.$refs.commonLoader.hideCommonLoadigIcon();
          if (res.data.code == 1) {
            if (res.data.data.withdrawal == 0) {
              that.showWithdrawlPassPopup();
              return;
            }
           
            // if (res.data.data.bank == 0) {
            //   that.showWithdrawlBankPopup();
            //   return;
            // }
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        })
        .catch(() => {
          that.$dialog
            .alert({
              title: "线路异常",
              message: "网络状态异常， 请尝试切换线路。",
              confirmButtonText: "切换线路",
            })
            .then(() => {
              that.$router.push({ path: "/api_line_selector" });
            });
        });
    },
    getWithdrawChannelInfo() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "withdraw_channel",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (res.data.code == 1) {
            that.withdraw_fee_percentage = resData.data.withdraw_fee_percentage;
            that.withdraw_fee_min = resData.data.withdraw_fee_min;
          } else if (res.data.code == 0 || res.data.code == -1) {
            // that.$toast.fail(resData.msg);
          }
        });
    },
 showWithdrawAddressPopup() {
      let that = this;
      Dialog.confirm({
        title: "",
        message: "您尚未设置提现地址，因此无法提现。请尽快设置。",
        cancelButtonText: "取消",
        confirmButtonText: "去设置",
      })
        .then(() => {
          that.$router.push({ name: "WithdrawAddress" });
        })
        .catch(() => {
          that.$router.go(-1);
        });
    },
    showWithdrawlPassPopup() {
      let that = this;
      Dialog.confirm({
        title: "",
        message: "您还没有设置提现密码，不能提现，请前去设置",
        cancelButtonText: "取消",
        confirmButtonText: "去设置",
      })
        .then(() => {
          that.$router.push({ name: "WithdrawalPass" });
        })
        .catch(() => {
          that.$router.go(-1);
        });
    },
    showWithdrawlBankPopup() {
      let that = this;
      Dialog.confirm({
        title: "",
        message: "请先设置提现银行卡才能提现",
        cancelButtonText: "取消",
        confirmButtonText: "去设置",
      })
        .then(() => {
          that.$router.push({ name: "BindBank" });
        })
        .catch(() => {
          that.$router.go(-1);
        });
    },
    //查询提现是否有银行卡
    getAccountbank() {
      let that = this;
      let radio = that.withdrawType[that.radio].type;
      if (that.money == "") {
        that.$toast.fail("请输入提现金额");
        return false;
      } else if (that.password == "") {
        that.$toast.fail("请输入提现密码");
        return false;
      } else if (radio == 2 && (that.gxpay_id == "" || that.gxpay_id == undefined)) {
        that.$toast.fail("请输入您的GXPay ID");
        return false;
      } else if (radio == 2 && that.confirmChecked == false) {
        that.$toast.fail("请核对您的Gxpay ID 后再确认提现操作");
        return false;
      }
      switch (radio) {
        case 2:
          that.$refs.commonLoader.showCommonLoadigIcon();
          that.withdraw_has();
          break;
        case 3:
          that.$refs.commonLoader.showCommonLoadigIcon();
          that.withdraw_has();
          break;
        default:
          that.$refs.commonLoader.showCommonLoadigIcon();
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "accountbank",
                token: sessionStorage.getItem("token"),
              },
            })
            .then(function (res) {
              // toast.clear();
              that.$refs.commonLoader.hideCommonLoadigIcon();
              let resData = res.data;
              if (res.data.code == 1) {
                if (resData.data.length === 0) {
                  that.$toast({
                    type: "fail",
                    message: "还未绑定银行卡,请前去绑定银行卡才可提现",
                    onClose: function () {
                      that.$router.push("/member/information");
                    },
                  });
                } else {
                  that.bankCardList = resData.data;
                  that.account = that.bankCardList[0].account;
                  that.card = that.bankCardList[0].card;
                  that.name = that.bankCardList[0].name;
                  that.address = that.bankCardList[0].address;
                  that.withdraw_has();
                }
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$toast.fail(res.data.msg);
              }
            })
            .catch(() => {
              that.$toast.fail(that.$NoNetworkErrorMsg);
              that.$dialog
                .alert({
                  title: "线路异常",
                  message: "网络状态异常， 请尝试切换线路。",
                  confirmButtonText: "切换线路",
                })
                .then(() => {
                  that.$router.push({ path: "/api_line_selector" });
                });
            })
            .finally(() => {
              that.$refs.commonLoader.hideCommonLoadigIcon();
            });
          break;
      }
    },

    withdraw_has() {
      let that = this;
      let number = that.money;
      // let toast = that.$toast.loading({
      //   forbidClick: true,
      // });
      that.$refs.commonLoader.showCommonLoadigIcon();
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "withdraw_has",
            token: sessionStorage.getItem("token"),
            number: number,
          },
        })
        .then(function (res) {
          // toast.clear();
          that.$refs.commonLoader.hideCommonLoadigIcon();
          let resData = res.data;
          if (resData.code == 0) {
            // that.withdrawal();
            that.WithdrawPopup();
          } else {
            Dialog.confirm({
              title: "",
              message:
                "您已提交一笔同金额的提现正在审核处理中\n若非新提现请勿重复提交 提示",
              cancelButtonText: "非新提现",
              confirmButtonText: "继续新提现",
            })
              .then(() => {
                that.WithdrawPopup();
              })
              .catch(() => {});
          }
        })
        .catch(() => {
          that.withdrawal();
        });
    },

    WithdrawPopup() {
      let that = this;
      // let toast = that.$toast.loading({
      //   forbidClick: true,
      // });
      that.$refs.commonLoader.showCommonLoadigIcon();
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            action: "withdraw_popup",
          },
        })
        .then(function (res) {
          // toast.clear();
          that.$refs.commonLoader.hideCommonLoadigIcon();
          if (res.data.code == 1) {
            that.popupStatus = res.data.data.is_withdraw_popup;
            that.timbaoAnulaizedInterestRate =
              res.data.data.timebao_annualized_interest_rate;
            that.timebaoRate = res.data.data.timebao_rate;
             that.withdraw_popup_content=res.data.data.withdraw_popup_content;
            that.left_side_button_name=res.data.data.left_side_button_name;
            that.right_side_button_name=res.data.data.right_side_button_name;
            that.mobile_left_side_redirection=res.data.data.mobile_left_side_redirection;
            that.secondWithdrawalPopup();
          } else if (res.data.code == 0) {
            that.$toast.fail(res.data.msg);
          }
        })
        .catch(() => {
          that.withdrawal();
        });
    },

    secondWithdrawalPopup() {
      let that = this;
      if (that.popupStatus == 1) {
        this.withdrawSecondPopup=true;

//         Dialog.confirm({
//           title: "稳定币基金大额奖 ，2天收益2%+",
//           message:  `
// <pre style="
//   margin: 0;
//   padding: 0;
//   text-align: left;
//   white-space: pre-wrap;
//   font-family: inherit;
//   margin-bottom: -30px;
//   line-height: 1.4;
// ">
// 1 买入2日基金，1万元起，收益0.24%.
// 2 基金转出后配资，交易额10倍，收益2%
// </pre>
//   `,
//           cancelButtonText: "转入稳定币基金",
//           confirmButtonText: "继续提现",
//           cancelButtonColor: "#D02E27",
//         })
//           .then(() => {
//             that.withdrawal();
//           })
//           .catch(() => {
//             that.$router.push("/member/stable_coinbao");
//           });
      } else {
        that.withdrawal();
      }
    },
    handleAmount(amount) {
      let that = this;
      that.money = amount;
    },
    //提现
    withdrawal() {
      let that = this;
      that.withdrawDisabled=true;
      let withdraw = that.withdrawType[that.radio];
      if (that.money == "") {
        that.$toast.fail("请输入提现金额");
        return false;
      } else if (that.password == "") {
        that.$toast.fail("请输入提现密码");
        return false;
      } else if (
        withdraw.type == 2 &&
        (that.gxpay_id == "" || that.gxpay_id == undefined)
      ) {
        that.$toast.fail("请输入您的GXPay ID");
        return false;
      } else if (withdraw.type == 2 && that.confirmChecked == false) {
        that.$toast.fail("请核对您的Gxpay ID 后再确认提现操作");
        return false;
      } else {
        // let toast = that.$toast.loading({
        //   forbidClick: true,
        // });
        switch (withdraw.type) {
          case 2:
            that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "withdraw",
                  token: sessionStorage.getItem("token"),
                  number: that.money,
                  password: that.password,
                  id: withdraw.id,
                  type: withdraw.type,
                  gxpay_id: that.gxpay_id,
                },
              })
              .then(function (res) {
                // toast.clear();
                that.$refs.commonLoader.hideCommonLoadigIcon();
                if (res.data.code == 1) {
                  that.$toast.success({
                    message: "提现成功",
                    type: "success",
                    onClose: function () {
                      that.$router.push("/member/detailed_log");
                    },
                  });
                } else if (res.data.code == 0 || res.data.code == -1) {
                   that.withdrawDisabled=false;
                  that.$toast.fail(res.data.msg);
                }
              })
              .catch(() => {
                that.$toast.fail(that.$NoNetworkErrorMsg);
              });

            break;
          default:
            that.$refs.commonLoader.showCommonLoadigIcon();
            that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "withdraw",
                  token: sessionStorage.getItem("token"),
                  number: that.money,
                  password: that.password,
                  name: that.name,
                  card: that.card,
                  id: withdraw.id,
                  type: withdraw.type,
                },
              })
              .then(function (res) {
                // toast.clear();
                that.$refs.commonLoader.hideCommonLoadigIcon();
                if (res.data.code == 1) {
                  that.$toast.success({
                    message: "提现成功",
                    type: "success",
                    onClose: function () {
                      that.$router.push("/member/detailed_log");
                    },
                  });
                } else if (res.data.code == 0 || res.data.code == -1) {
                   that.withdrawDisabled=false;
                  that.$toast.fail(res.data.msg);
                }
              })
              .catch(() => {
                that.$toast.fail(that.$NoNetworkErrorMsg);
              });
            break;
        }
      }
    },
    // ============= get the content of trade channel popup agreement ===========
    getTradeChannel() {
      let that = this;
      // Toast.loading();
      that.$refs.commonLoader.showCommonLoadigIcon();
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "trade_popup",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            // Toast.clear();
            that.$refs.commonLoader.hideCommonLoadigIcon();
            that.trade_rules_content_top = res.data.data.content_top;
            that.trade_rules_content_bottom = res.data.data.content_bottom;
            that.showTradeChannelPopup = true;
          } else {
            // Toast.clear();
            that.$refs.commonLoader.hideCommonLoadigIcon();
            // that.$toast.fail(res.data.msg);
          }
        });
    },

    // ============================== Click agree the trade rules ========================
    agreeTradeRules() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "modify_trade_status",
            token: sessionStorage.getItem("token"),
            trade_channel_status: 1,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.$toast.success({
              message: res.data.msg,
            });
            that.showTradeChannelPopup = false;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
    getWithdrawTypes() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "withdraw_type",
            app_version: version,
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            let resData = res.data;
            let withdrawType = resData.data;
            for (let i = 0, len = withdrawType.length; i < len; i++) {
              if (withdrawType[i].isdefault == 1) {
                that.radio = i;
              }
            }
            that.withdrawType = withdrawType;
            let SelectedType = withdrawType[that.radio];
            that.notice_1_1 = SelectedType.notice_1_1;
            that.notice_2_1 = SelectedType.notice_2_1;
            that.notice_2_2 = SelectedType.notice_2_2;
            that.button_text = SelectedType.button_text;
            that.auto_fill_amounts = SelectedType.auto_fill_amounts;
            that.selectedTypeId = SelectedType.id;
            that.selected_type = SelectedType.type;
            that.usdt.exchange_rate=SelectedType.exchange_rate?SelectedType.exchange_rate:0;
            that.getUserWithdrawAddress(SelectedType.type);
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
    changeInstructions(index, type) {
      let that = this;
      that.radio = index;
      let SelectedType = that.withdrawType[index];
      that.selectedTypeId = SelectedType.id;
      that.notice_1_1 = SelectedType.notice_1_1;
      that.notice_2_1 = SelectedType.notice_2_1;
      that.notice_2_2 = SelectedType.notice_2_2;
      that.button_text = SelectedType.button_text;
      that.auto_fill_amounts = SelectedType.auto_fill_amounts;
      that.selected_type = SelectedType.type;
      that.money = "";
      that.confirmChecked = false;
      that.usdt.exchange_rate=SelectedType.exchange_rate?SelectedType.exchange_rate:0;
       that.getUserWithdrawAddress(SelectedType.type);
        that.getGxpayId();
    },
     getUserWithdrawAddress($selected_type){
       let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "user_info",
            token: sessionStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.usdt.user_withdraw_address=res.data.data.withdraw_address;
             that.usdt.is_user_bank=res.data.data.bank;
            if($selected_type==3 && res.data.data.withdraw_address==null){
              that.showWithdrawAddressPopup();
            }
            else if($selected_type!=3 && res.data.data.bank==0){
              that.showWithdrawlBankPopup();
            }
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    getGxpayId() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "gxpay_thirdparty_digital_currency",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            let resData = res.data;
            if (resData.data.user == true) {
              that.gxpay_id = resData.data.numberId;
            } else {
              if (that.selected_type == 2) {
                window.open(resData.data.homeUrl, "_blank");
                that.$router.push("/member/members");
              }
            }
          }
        });
    },
  },
  mounted: function () {
    this.get_qchat_server_url();
    this.isLogin();
    this.getUser();
    this.getUserInfo();
    this.getWithdrawChannelInfo();
    this.getWithdrawTypes();
    this.getGxpayId();
  },
};
</script>

<style scoped>
.rowStyle {
  padding: 10px 16px;
  border-bottom: 1px solid #ebedf0;
  font-size: 14px;
}
.chatTextDesign {
  color: #ffffff;
  font-size: 14px;
  padding: 0px 12px;
  border-radius: 6px;
}
#rechargetop {
  margin: 15px 18px 15px 15px !important;
  border: 1px solid #f0f0f0 !important;
  border-radius: 20px !important;
  background-color: #f0f0f0;
  overflow: hidden;
}
#rechargetop h5 {
  margin-top: 12px;
  margin-left: 15px !important;
  font-size: 16px !important;
}
#rechargetop h4 {
  margin-left: 15px !important;
  font-size: 12px !important;
}
#gxpay {
  margin: 10px 18px 5px 15px !important;
  border: 1px solid #f0f0f0 !important;
  border-radius: 10px !important;
  background-color: #f0f0f0;
  overflow: hidden;
}
.autofill {
  padding-left: 20px;
  padding-top: 10px;
}
.autofillbtn {
  background: linear-gradient(45deg, #ff3b3b, #d02e27) !important;
  color: #ffffff !important;
  border: none !important;
  width: 70px;
  height: 30px;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px !important;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease-in-out;
}
.recharge-notice {
  padding-left: 20px;
  padding-right: 20px;
  margin-top: -10px;
  margin-bottom: -10px;
  overflow: hidden;
}
/* .enterAmount {
  color: #333333;
  font-size: 22px;
  padding: 20px 0px 10px;
  margin: 0px;
  font-weight: 700;
} */
.inputBg {
  background: #f0f0f0;
  border-radius: 12px;
  padding: 10x;
  display: flex;
  align-items: center;
}
#passwordstyle {
  margin: 2px 18px 2px 18px !important;
}
#passwordstyle h4 {
  font-size: 16px;
}
.rechargeTypeBg {
  margin: 18px;
  background: #ffffff;
  border: 1px solid #f0f0f0;
  border-radius: 15px;
  padding: 10px;
  display: flex;
  align-items: center;
  font-size: 14px;
}
#submitbtn {
  margin: 5px 18px 5px 18px !important;
}
/deep/ .van-radio__icon--checked .van-icon {
  color: #fff !important;
  background-color: #3f7a21 !important;
  border-color: #3f7a21 !important;
}
/deep/ .van-checkbox__icon--checked .van-icon {
  color: #fff;
  background-color: #3f7a21 !important;
  border-color: #3f7a21 !important;
}
/deep/ .van-field__label {
  color: #000000;
}
</style>

<style>
#tradingAgreePop p {
  margin: 0 !important;
}

#tradingAgreePop .van-popup__close-icon--top-right {
  top: 0px;
  right: 0px;
}
#rechargetop .van-field__label {
  font-size: 28px;
  margin-left: 0px;
}
#rechargetop .van-field__control {
  color: #000000 !important;
  text-align: left;
  font-size: 14px;
}
#gxpay .van-cell {
  background-color: #f0f0f0;
}
#gxpay .van-field__label {
  font-size: 14px;
}
#gxpay .van-field__control {
  color: #000000 !important;
  font-size: 12px;
}
#gxpay .van-checkbox__label {
  color: #000000 !important;
  font-size: 12px;
}
#inputAmountWithdraw .van-cell {
  background-color: transparent !important;
  font-size: 16px;
}
#submitbtn .van-button {
  background-color: #d02e27 !important;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Withdrawal.vue